import { render, staticRenderFns } from "./CookiesBar.vue?vue&type=template&id=309e7013"
import script from "./CookiesBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookiesBar.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309e7013')) {
      api.createRecord('309e7013', component.options)
    } else {
      api.reload('309e7013', component.options)
    }
    module.hot.accept("./CookiesBar.vue?vue&type=template&id=309e7013", function () {
      api.rerender('309e7013', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/cookies/CookiesBar.vue"
export default component.exports